import { render } from "./index.vue?vue&type=template&id=846eca06&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=846eca06&lang=scss&scoped=true"

import exportComponent from "F:\\project\\2023\\山东博物馆大屏\\shandong\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-846eca06"]])

export default __exports__